import _ from 'lodash';
//
// mutations are used by both the state machine and Vue.
// Vue URI requests (e.g. navigation bar activities) will 
// be events as well.

export const setCsrf = "setCsrf";
export const LoggedOut = "LoggedOut";
export const LoggedIn = "LoggedIn";
export const setAllWatches = "setAllWatches";
export const clearAllWatches = "clearAllWatches";
export const removeCheckedMeasure = "removeCheckedMeasure";
export const addCheckedMeasure = "addCheckedMeasure";
export const addTrendCheckedMeasure = "addTrendCheckedMeasure"
export const removeMeasure = "removeMeasure";
export const addMeasure = "addMeasure";
export const removeProcedure = "removeProcedure";
export const addProcedure = "addProcedure";
export const setReport = "setReport";
export const clearReport = "clearReport";
export const setPdf = "setPdf";
export const clearPdf = "clearPdf";
export const setCda = "setCda";
export const clearCda = "clearCda";
export const setApplicationModel = "setApplicationModel";
export const setRotation = "setRotation";
export const resetCheckedVitals = "resetCheckedVitals"

export let allMutations = [
  setCsrf,
  LoggedOut,
  LoggedIn,
  setAllWatches,
  clearAllWatches,
  removeCheckedMeasure,
  addCheckedMeasure,
  addTrendCheckedMeasure,
  removeMeasure,
  addMeasure,
  removeProcedure,
  addProcedure,
  setReport,
  clearReport,
  setPdf,
  clearPdf,
  setCda,
  clearCda,
  setApplicationModel,
  resetCheckedVitals
];
